import { __module as sharedStore } from './_virtual-shared-store.js';
import { __require as requireIsPure } from './node_modules-core-js-internals-is-pure.js';
import { __require as requireGlobalThis } from './node_modules-core-js-internals-global-this.js';
import { __require as requireDefineGlobalProperty } from './node_modules-core-js-internals-define-global-property.js';

var hasRequiredSharedStore;

function requireSharedStore () {
	if (hasRequiredSharedStore) return sharedStore.exports;
	hasRequiredSharedStore = 1;
	var IS_PURE = requireIsPure();
	var globalThis = requireGlobalThis();
	var defineGlobalProperty = requireDefineGlobalProperty();

	var SHARED = '__core-js_shared__';
	var store = sharedStore.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});

	(store.versions || (store.versions = [])).push({
	  version: '3.45.0',
	  mode: IS_PURE ? 'pure' : 'global',
	  copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru)',
	  license: 'https://github.com/zloirock/core-js/blob/v3.45.0/LICENSE',
	  source: 'https://github.com/zloirock/core-js'
	});
	return sharedStore.exports;
}

export { requireSharedStore as __require };
//# sourceMappingURL=node_modules-core-js-internals-shared-store.js.map
